import { render, staticRenderFns } from "./TopTours.vue?vue&type=template&id=9d45a92e"
import script from "./TopTours.vue?vue&type=script&lang=js"
export * from "./TopTours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports